<template>
  <div>
    <QueryFrame
      :count="count"
      :current="page"
      @handlePage="handlePage"
      @handlePageSize="handlePageSize">
      <div slot="queryParams">
        <div class="queryContainer">
          <div class="queryItem">
            <label>商品搜索:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.nameMix"></lk-input>
          </div>

          <div class="queryItem">
            <label>生成厂家:</label>
            <lk-input :maxlength="100" placeholder="请输入" class="item" clearable v-model.trim="query.producer"></lk-input>
          </div>
          <div class="queryItem">
            <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
            <lk-button @click="handleReset">重置</lk-button>
          </div>
        </div>
      </div>
      <div slot="table">
        <div class="btns" v-if="handlePermission('updateGoodsMap')">
          <lk-button type='primary' @click='uploadGoodsMap'>上传未对应目录(907)</lk-button>
          <lk-button type='primary' @click='updateGoodsMap'>更新目录对码表(908)</lk-button>

        </div>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>
<script>
import QueryFrame from '../../../components/frame/QueryFrame.vue';
import utils from '../../../libs/utils';
import insurance from '../../../services/insurance';
import mapState from '../../../mixins/mapState'; // 鉴权
import queryMixins from '../../../mixins/queryMixins';

export default {
  name: 'CatalogComparison',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
  },
  computed: {},
  data() {
    return {
      query: {

      },
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
          indexMethod: row => (row._index + this.size * (this.page - 1)) + 1,
        },
        {
          title: '所属经办机构',
          key: 'akb020',
          minWidth: 116,
        },
        {
          title: '目录对应流水号',
          key: 'aae073',
          minWidth: 116,
        },
        {
          title: '医院三大目录项目编码',
          key: 'bka262',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '医保三大目录项目编码',
          key: 'bka261',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '医院三大目录项目名称',
          key: 'bka263',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '医保三大目录项目名称',
          key: 'bka264',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '目录类别',
          key: 'aka213',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '操作',
          minWidth: 116,
          render: (h, params) => h('lk-button', {
            props: {
              type: 'primary',
            },
            on: {
              click: () => {
                insurance.goodsMapCancel({ BKA262: params.row.bka261 }).then((res) => {
                  if (res.data.status === 200) {
                    this.$Message.success('取消成功');
                  } else {
                    this.$Message.error(res.data.error);
                  }
                }).catch((err) => {
                  utils.handleError(err);
                });
              },
            },
          }, '取消对应'),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    handleReset() {
      this.query = {};
    },
    updateGoodsMap() {
      insurance.goodsMapUpdate().then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('上传成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    uploadGoodsMap() {
      insurance.goodsMapUpload().then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('上传成功');
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },

    getData() {
      this.params.page = this.page;
      this.params.size = this.size;
      insurance.goodsMapList(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.count = count;
          this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    if (!this.handlePermission('updateGoodsMap')) {
      this.columns.splice(this.columns.length - 1);
    }


    this.handleSearch(true);
  },
};
</script>
<style lang="less" scoped>
.btns{
  margin-bottom: 8px;
  >*{
    margin-right: 8px
  }
}
</style>
